/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateUserDtoGen,
  MrfiktivExceptionViewmodelGen,
  MrfiktivPageViewModelGen,
  MrfiktivPartnerFleetUserControllerFindAllByFleetByPartnerIdParamsGen,
  MrfiktivPartnerFleetUserControllerFindAllByPartnerIdParamsGen,
  MrfiktivPartnerFleetUserPermissionDtoGen,
  MrfiktivPartnerUserViewModelGen,
  MrfiktivUserIdentityViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FleetUsers<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerCreate
   * @summary Create a user
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/user
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The created user
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `409` `MrfiktivExceptionViewmodelGen` A user with this email already exists
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerCreate = (
    partnerId: string,
    fleetId: string,
    data: MrfiktivCreateUserDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerFindAllByFleetByPartnerId
   * @summary Get all users for a fleet by partner
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/user
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivPartnerUserViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerFindAllByFleetByPartnerId = (
    { partnerId, fleetId, ...query }: MrfiktivPartnerFleetUserControllerFindAllByFleetByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & { data?: MrfiktivPartnerUserViewModelGen[] },
      MrfiktivExceptionViewmodelGen
    >({
      path: `/partner/${partnerId}/fleet/${fleetId}/user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerInvite
   * @summary (CREATE - USER) Creates an new user and send invitation email to new user.
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/user/invite
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The invited user with read permissions
   * @response `400` `void` Bad request.
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `void` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerInvite = (
    partnerId: string,
    fleetId: string,
    data: MrfiktivCreateUserDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, void | MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerFindAllByPartnerId
   * @summary Get all fleet users for a partner
   * @request GET:/partner/{partnerId}/fleet/user
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivPartnerUserViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerFindAllByPartnerId = (
    { partnerId, ...query }: MrfiktivPartnerFleetUserControllerFindAllByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & { data?: MrfiktivPartnerUserViewModelGen[] },
      MrfiktivExceptionViewmodelGen
    >({
      path: `/partner/${partnerId}/fleet/user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerFindOneByPartnerId
   * @summary Get a user by id
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/user/{id}
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The found user
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerFindOneByPartnerId = (
    partnerId: string,
    fleetId: string,
    id: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerFindOneByNameAndPartnerId
   * @summary Get a user by username
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/user/{username}/byName
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The found user
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerFindOneByNameAndPartnerId = (
    partnerId: string,
    fleetId: string,
    username: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/${username}/byName`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerGetUserStatusByPartnerId
   * @summary Get a user by id
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/user/{id}/status
   * @secure
   * @response `200` `MrfiktivUserIdentityViewModelGen` The found user
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerGetUserStatusByPartnerId = (
    partnerId: string,
    fleetId: string,
    id: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivUserIdentityViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/${id}/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * @description <p>This endpoint can be used in the admin sign up flow</p> <ol> <li>Partner invites a User</li> <li>User lost invitation mail or temporary password is exceeded (Status is still FORCE_CHANGE_PASSWORD)</li> <li>Use this endpoint to resend invitation mail for a user from the user pool</li> </ol> <p>Summary: Resend invitation for an invited user in case the user lost the initial mail. Is only working is the user status is FORCE_CHANGE_PASSWORD</p>
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerResendInvitation
   * @summary Resend invitation for an invited user in case the user lost the initial mail. Is only working if the user status is FORCE_CHANGE_PASSWORD
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/user/{id}/resendInvitationMessage
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The reinvited user
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerResendInvitation = (
    partnerId: string,
    fleetId: string,
    id: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/${id}/resendInvitationMessage`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerAddPermission
   * @summary Add a permission to a user by id
   * @request PATCH:/partner/{partnerId}/fleet/{fleetId}/user/{id}/permission/add
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The updated record
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerAddPermission = (
    partnerId: string,
    fleetId: string,
    id: string,
    data: MrfiktivPartnerFleetUserPermissionDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/${id}/permission/add`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Users
   * @name PartnerFleetUserControllerRemovePermission
   * @summary Removes a permission for a user by id
   * @request PATCH:/partner/{partnerId}/fleet/{fleetId}/user/{id}/permission/remove
   * @secure
   * @response `200` `MrfiktivPartnerUserViewModelGen` The updated record
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerFleetUserControllerRemovePermission = (
    partnerId: string,
    fleetId: string,
    id: string,
    data: MrfiktivPartnerFleetUserPermissionDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerUserViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/fleet/${fleetId}/user/${id}/permission/remove`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
